<div class="db-optimizer-loading">
  <div class="db-optimizer-loading__content">
    <db-loading-spinner [size]="100"></db-loading-spinner>
    <div [innerHTML]="'text_optimizationProgress' | dbText"></div>
  </div>
</div>
